//Site Reliability Assessment
(function() {

	window.sitra = new function() {
	  var _ = this;

	  _.class = "sitra";
    _.new_assign = false;

	  //Initialisation
	  _.init = function() {
      if(!_.integrity.check()) _.integrity.assign();
      _.createEventHandlers();
	  	_.acknowledge("initialisation complete");
	  }

	  _.createEventHandlers = function() {
      document.addEventListener("click",_.service.interact,true);
	  }

    _.integrity = new function() {
      var __ = this;
      __.check = function() {
        return _.utility.cookie.get("dma_stat")==""?false:true;
      }
      __.assign = function() {
        _.utility.cookie.set("dma_stat",_.utility.create_key(),90);
        _.new_assign = true;
        _.test.init();
      }
      __.verify = function(data) {
        console.log(data);
        var j_data = JSON.parse(data);
        if(j_data.hasOwnProperty("response_prekey")) { //dBase returned extant data, so align local store
          _.utility.cookie.set("dma_stat",j_data.response_prekey,90);
        }
      }
    }

    _.service = new function() {
      var __ = this;
      __.log = function(action,parent = undefined) {
        var t_data = {
          prekey:_.utility.cookie.get("dma_stat"),
          agent_id:_.utility.md5(navigator.userAgent),
          url:window.location.pathname,
          action:action,
          keystate:_.new_assign,
          x:screen.width,
          y:screen.height,
          w:window.innerWidth,
          h:window.innerHeight
        }
        if(typeof(parent)!="undefined") t_data.parent = parent;
        if(sessionStorage.hasOwnProperty("account_data")) {
          var j_data = JSON.parse(sessionStorage.account_data);
          t_data.local_id = j_data.local_id;
          t_data.remote_id = j_data.hasOwnProperty("remote_id")?j_data.remote_id:false;
        } else {
          t_data.local_id = "";
          t_data.remote_id = "";
        }
        _.utility.request.post("https://accounts.togetherhealth.co.uk/sitra/action/",t_data,_.integrity.verify);
        _.new_assign = false;
      }
      __.interact = function(e) {
        var element = e.target;
        if(element.tagName!="A"&&element.tagName!="INPUT"&&element.tagName!="BUTTON"&&element.closest("a")) element = element.closest("a");
        if(element.tagName=="A"||element.tagName=="INPUT"||element.tagName=="BUTTON") {
          __.log("click",element.closest("[id]").getAttribute("id"));
        }
      }
    }

    _.test = new function() {
      var __ = this;
      __.init = function() {
      }
    }
    
    _.action = new function() {
      var __ = this;
      __.claim = function($element) {
      }
    }

    _.utility = new function() {
      var __ = this;
      __.request = new function() {
        var ___ = this;
        ___.get = function(url,after) {
          const xhttp = new XMLHttpRequest();
          xhttp.open("GET",url); 
          xhttp.onload = () => {
            var response = this.responseText;
            after(response);
          };
          xhttp.send(null);
        }
        ___.post = function(url,data,after) {
          const xhttp = new XMLHttpRequest();
          xhttp.open("POST",url,true);
          xhttp.setRequestHeader("Content-Type","application/x-www-form-urlencoded");
          xhttp.onreadystatechange = function() {
             if(this.readyState == 4 && this.status == 200) {
               var response = this.responseText;
               after(response);
             }
          };
          let urlEncodedData = "", urlEncodedDataPairs = [], name;
          for(name in data) {
            urlEncodedDataPairs.push(encodeURIComponent(name)+'='+encodeURIComponent(data[name]));
          }
          urlEncodedData = urlEncodedDataPairs.join("&");
          xhttp.send(urlEncodedData);
        }
      }
      __.cookie = new function() {
        var ___ = this;
        ___.get = function(cname) {
          var name = cname + "=";
          var ca = document.cookie.split(';');
          for(var i=0;i<ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') {
              c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
              return c.substring(name.length,c.length);
            }
          }
          return "";
        }
        ___.set = function(cname, cvalue, exdays) {
          var d = new Date();
          d.setTime(d.getTime() + (exdays*86400000));
          var expires = "expires="+ d.toUTCString();
          document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
        }
      }
      __.create_key = function() {
        var pool = "1234567890abcdef";
        var tkey = "";
        for(var i=0;i<32;i++) tkey += pool.substr(parseInt(Math.random()*pool.length),1);
        return tkey;
      }
      __.md5 = function(r) {
        var o, e, n, f = [ -680876936, -389564586, 606105819, -1044525330, -176418897, 1200080426, -1473231341, -45705983, 1770035416, -1958414417, -42063, -1990404162, 1804603682, -40341101, -1502002290, 1236535329, -165796510, -1069501632, 643717713, -373897302, -701558691, 38016083, -660478335, -405537848, 568446438, -1019803690, -187363961, 1163531501, -1444681467, -51403784, 1735328473, -1926607734, -378558, -2022574463, 1839030562, -35309556, -1530992060, 1272893353, -155497632, -1094730640, 681279174, -358537222, -722521979, 76029189, -640364487, -421815835, 530742520, -995338651, -198630844, 1126891415, -1416354905, -57434055, 1700485571, -1894986606, -1051523, -2054922799, 1873313359, -30611744, -1560198380, 1309151649, -145523070, -1120210379, 718787259, -343485551 ], t = [ o = 1732584193, e = 4023233417, ~o, ~e ], c = [], a = unescape(encodeURI(r)) + "\u0080", d = a.length;
        for (r = --d / 4 + 2 | 15, c[--r] = 8 * d; ~d; ) c[d >> 2] |= a.charCodeAt(d) << 8 * d--;
        for (i = a = 0; i < r; i += 16) {
            for (d = t; 64 > a; d = [ n = d[3], o + ((n = d[0] + [ o & e | ~o & n, n & o | ~n & e, o ^ e ^ n, e ^ (o | ~n) ][d = a >> 4] + f[a] + ~~c[i | 15 & [ a, 5 * a + 1, 3 * a + 5, 7 * a ][d]]) << (d = [ 7, 12, 17, 22, 5, 9, 14, 20, 4, 11, 16, 23, 6, 10, 15, 21 ][4 * d + a++ % 4]) | n >>> -d), o, e ]) o = 0 | d[1], 
            e = d[2];
            for (a = 4; a; ) t[--a] += d[a];
        }
        for (r = ""; 32 > a; ) r += (t[a >> 3] >> 4 * (1 ^ a++) & 15).toString(16);
        return r;
      }

    }
    
	  //System level operations
	  _.acknowledge = function(message) {
	  	console.log(message + " [from " + _.class + " func]");
	  }
	}

	sitra.init();

})();